/** @jsx jsx */
import { css, jsx } from '@compiled/react';
import Heading from '@atlaskit/heading';
import { Box, Text, xcss } from '@atlaskit/primitives';

export const EmptyState = ({
	icon,
	headingText,
	descriptionText,
	actionButton,
}: {
	icon: React.ReactNode;
	headingText: React.ReactNode;
	descriptionText: React.ReactNode;
	actionButton?: React.ReactNode;
}) => {
	return (
		<div css={containerStyles}>
			{icon}
			<div css={textContainerStyles}>
				<Heading size="small" as="h2">
					{headingText}
				</Heading>
				<Text>{descriptionText}</Text>
			</div>
			{actionButton && <Box xcss={actionButtonContainerStyles}>{actionButton}</Box>}
		</div>
	);
};

const containerStyles = css({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	flexDirection: 'column',
	height: '100%',
});

const textContainerStyles = css({
	maxWidth: '400px',
	textAlign: 'center',
});

const actionButtonContainerStyles = xcss({
	marginTop: 'space.300',
});
